import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { fundingSourceActions, httpRequestsOnSuccessActions, invoiceActions, systemActions } from 'store';
import { AccordionFullTable, SelectActions } from 'components';
import { FindLoad, FindSuccessItem, Images, PermissionList, RolePermission, convertHours, formatNumberToFix, splitCptServiceFilter } from 'utils';
import { Skeleton } from '@mui/material';
import { GENERATE_ACTION_TYPE, GENERATE_INVOICE, invoiceableApptTableInfo } from './constants';

export const InvoicebleApt = () => {
    const location = useLocation();
    const info = location?.state;
    const dispatch = useDispatch();
    const notInvoicedBills = useSelector((state) => state.invoice.billForGenerate);
    const billTotals = useSelector((state) => state.invoice.billForGenerateTotals);
    const globalServices = useSelector((state) => state.fundingSource.fundingUniqueServices);
    const [selectedList, setSelectedList] = useState([]);
    const generateSuccess = FindSuccessItem(GENERATE_INVOICE);
    const loader = FindLoad(GENERATE_ACTION_TYPE);
    const bills = notInvoicedBills?.bills || [];
    const totalAppointments = billTotals?.totalAppointments || 0;
    const totalHours = billTotals?.totalHours || 0;
    const totalInvoiceableAmount = billTotals?.totalInvoiceableAmount || 0;

    useEffect(() => {
        dispatch(fundingSourceActions.fundingUniqueServices());
    }, [dispatch]);

    const applyCptServiceFilter = (pushInfo) => {
        const { cptCode, serviceTypeId } = splitCptServiceFilter(info?.cptCode);
        cptCode?.length ? (pushInfo.cptCode = cptCode) : delete pushInfo.cptCode;
        serviceTypeId?.length ? (pushInfo.serviceTypeId = serviceTypeId) : delete pushInfo.serviceTypeId;
        return pushInfo;
    };

    const renderParams = () => {
        const pushInfo = {
            ...info,
        };
        delete pushInfo.tabType;
        delete pushInfo.page;
        delete pushInfo.clientFull;
        pushInfo.skip = info?.skip ? info?.skip : 0;
        pushInfo.limit = 50;
        return applyCptServiceFilter(pushInfo);
    };

    const renderTotalsParams = () => {
        const pushInfo = { ...info };
        delete pushInfo.tabType;
        delete pushInfo.page;
        delete pushInfo.clientFull;
        delete pushInfo.skip;
        delete pushInfo.limit;
        return applyCptServiceFilter(pushInfo);
    };

    const getInvoices = (load) => {
        dispatch(invoiceActions.getInvoiceForGenerate({ ...renderParams() }, load));
        dispatch(invoiceActions.getInvoiceForGenerateTotals({ ...renderTotalsParams() }));
    };

    useEffect(() => {
        getInvoices();
    }, [info]);

    useEffect(() => {
        if (generateSuccess) {
            getInvoices('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(GENERATE_INVOICE));
            setSelectedList([]);
        }
    }, [generateSuccess]);

    const handleCheck = (ev, item, name) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (name === 'all') {
            const allList = notInvoicedBills?.bills?.length === selectedList?.length ? [] : notInvoicedBills?.bills?.map((i) => i?.id);
            setSelectedList(allList);
        } else {
            setSelectedList((prev) => (prev.includes(item?.id) ? prev.filter((id) => id !== item?.id) : [...prev, item?.id]));
        }
    };

    const removeSelectedList = () => {
        setSelectedList([]);
    };

    const generateInvoices = () => {
        const { cptCode, serviceTypeId } = splitCptServiceFilter(info?.cptCode);
        dispatch(invoiceActions.generateInvoice({ bills: selectedList, cptCode, serviceTypeId }));
    };

    return (
        <div>
            {loader?.length ? (
                <div style={{ margin: '0 0 6px 0' }}>
                    <Skeleton variant="rectangular" width={'100%'} height={60} style={{ borderRadius: '8px' }} />
                </div>
            ) : (
                <div className="aging-section-box" style={{ justifyContent: 'flex-end', margin: '24px 0 6px 0' }}>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Appointments</p>
                        <div className="billing-total-price-row">
                            <span>{totalAppointments}</span>
                        </div>
                    </div>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Hours</p>
                        <div className="billing-total-price-row">
                            <span>{convertHours(totalHours)}</span>
                        </div>
                    </div>
                    <div className="billing-total-row">
                        <p className="billing-total-title">Total Invoiceable Amount</p>
                        <div className="billing-total-price-row">
                            <NumericFormat
                                value={formatNumberToFix(totalInvoiceableAmount)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                </div>
            )}

            {RolePermission([PermissionList.INVOICE_CREATE?.code]) && !!selectedList?.length && (
                <SelectActions
                    submitText={'Generate Invoices'}
                    submitBtnIcon={Images.addCircle}
                    actionType={GENERATE_INVOICE}
                    selectedList={selectedList?.length}
                    selectAll={handleCheck}
                    submitClaims={generateInvoices}
                    removeSelected={removeSelectedList}
                />
            )}

            <AccordionFullTable
                margin={'6px 0 0 0'}
                tableInfo={invoiceableApptTableInfo(handleCheck, notInvoicedBills?.bills, selectedList, globalServices)}
                list={bills}
                listCount={notInvoicedBills?.count}
                selectedList={selectedList}
            />
        </div>
    );
};
